import React from 'react';
import { motion } from 'framer-motion';
import { EASE_OUT } from '../../utils/motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className = ''
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: EASE_OUT
  }} data-id="element-262" data-mp="ydowg86pqqim">
      {children}
    </motion.div>;
}